import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  TablePagination,
  Box,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogActions,
  Grid,
  Popover,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import {
  ApiGetAllRoles,
  ApiGetAdminList,
  ApiPutUpdateAdminRole,
  ApiPutUpdateAdminStatus,
  ApiGetShoppersApplication,
  ApiPutUpdateShopperApplicationStatus,
  ApiDeleteUser,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { Autocomplete as GoogleAutocomplete } from "@react-google-maps/api";

const stateOptions = [
  { label: "Victoria", value: "VIC" },
  { label: "Western Australia", value: "WA" },
  { label: "South Australia", value: "SA" },
  { label: "Queensland", value: "QLD" },
  { label: "Australian Capital Territory", value: "ACT" },
  { label: "New South Wales", value: "NSW" },
  { label: "Tasmania", value: "TAS" },
  { label: "Northern Territory", value: "NT" },
];

const statusOptions = [
  { label: "Pending", value: "pending" },
  { label: "Reject", value: "reject" },
];

interface LocationData {
  city: string;
  state: string;
}

const ShopperApplications: React.FC = () => {
  const [shopperApplications, setShopperApplications] = useState<any>([]);
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [state, setState] = useState<string>(
    sessionStorage.getItem("shopperState") || ""
  );

  const [searchShopper, setsearchShopper] = useState<any[]>(
    JSON.parse(sessionStorage.getItem("searchShopper") || "[]")
  );
  const [status, setStatus] = useState("pending");
  const [selectedShopper, setSelectedShopper] = useState<any>(null);
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [activeLocation, setActiveLocation] = useState<LocationData | null>(null);
  const [autocomplete, setAutocomplete] = useState<any>(null);
  const [inputValue, setInputValue] = useState("");
  const [suburb, setSuburb] = useState<string | null>(null);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    city: string,
    state: string
  ) => {
    setAnchorEl(event.currentTarget);
    setActiveLocation({ city, state });
  };

  useEffect(() => {
    sessionStorage.setItem("shopperState", state);
  }, [state]);

  useEffect(() => {
    sessionStorage.setItem("searchShopper", JSON.stringify(searchShopper));
  }, [searchShopper]);

  const handleClose = () => {
    setAnchorEl(null);
    setActiveLocation(null);
  };

  const open = Boolean(anchorEl);



  const navigate = useNavigate();

  const openEditAccessGroup = () => {
    navigate("/admin/edit-access-group");
  };
  const navigateToViewShopperApplication = (shopper) => {
    navigate("/admin/shoppers/view-shopper-application", {
      state: { shopperDetails: shopper },
    });
  };

  const updateApplicationStatus = async (shopper: any, updatedStatus: any, reason?: any) => {
    const data = {
      userId: shopper.userId,
      status: updatedStatus,
      rejectReason: reason
    };
    const response: any = await ApiPutUpdateShopperApplicationStatus(data);
    toast.success("Application Status updated successfully");
    await handleGetShoppers();
  };

  const fetchData = async () => {
    await handleGetShoppers();
  };

  useEffect(() => {
    fetchData();
    return () => { };
  }, [rowsPerPage, page, state, status, latitude, longitude]);


  const handleDeleteUser = async (userId: number) => {
    const isdelete = window.confirm("Are you sure you want to delete this shopper?")
    if(isdelete){
    try {
      const data = `?userId=${userId}`
      const res = await ApiDeleteUser(data)
      if (res?.status) {
        fetchData()
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
    }
  }


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleGetShoppers();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchShopper]);

  const handleGetShoppers = async () => {
    let queryParams = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}`;

    if (state) {
      queryParams += `&state=${state}`;
    }

    if (status) {
      queryParams += `&userStatus=${status}`;
    }

    if (searchShopper) {
      queryParams += `&search=${searchShopper}`;
    }
    if (latitude) {
      queryParams += `&lat=${latitude}`;
    }
    if (longitude) {
      queryParams += `&long=${longitude}`;
    }

    try {
      const response: any = await ApiGetShoppersApplication(queryParams);
      setdatalength(response.totalCount);
      setShopperApplications(response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function formatDateIfExists(isoDate) {
    if (!isoDate) return "";

    const dateObj = new Date(isoDate);
    if (isNaN(dateObj.getTime())) return ""; // invalid date

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();

    const formattedDateTime = `${day}/${month}/${year}`;
    return formattedDateTime;
  }


  function getDayGapFromToday2(targetDate): any {
    if (!targetDate) return "";

    const today = new Date();
    const givenDate = new Date(targetDate);

    if (isNaN(givenDate.getTime())) return "";

    // Zero out time (set to midnight)
    today.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);

    const diffTime = givenDate.getTime() - today.getTime();
    const diffDays = Math.abs(diffTime / (1000 * 60 * 60 * 24)); // ms to days

    return diffDays;
  }
  function getDayGapFromToday(targetDate: string) {
    if (!targetDate) return null;

    const today = new Date();
    const createdDate = new Date(targetDate);

    if (isNaN(createdDate.getTime())) return null;

    // remove time
    today.setHours(0, 0, 0, 0);
    createdDate.setHours(0, 0, 0, 0);

    const diffTime = today.getTime() - createdDate.getTime();
    const passedDays = diffTime / (1000 * 60 * 60 * 24);

    const remainingDays = 28 - passedDays;

    return remainingDays;
  }

  return (
    <div className="w-100 p-2">
      <Box className='bg-light p-3 border-10'>
        <Grid container className='w-100 mb-4' gap={2}>
          <Grid flexDirection={{ xs: "column", md: "row" }} className='mb-4 d-flex  align-items-center' gap={2} size={{ xs: 12, md: "auto" }} order={{ xs: 2, md: 1 }}>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
              <Autocomplete
                disablePortal
                id="mm-autocomplete"
                options={stateOptions}
                getOptionLabel={(option: any) => `${option?.label}`}
                value={stateOptions.find((option: any) => option.value === state) || null}
                onChange={(event, newValue: any) => {
                  setState(newValue?.value || null)
                }}
                defaultValue=""
                renderInput={(params) => <TextField {...params} label="Select State" />}
                size="small"
              />
            </FormControl>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
              <TextField sx={{
                "input": { padding: '9px' }, "& .MuiInputLabel-root": {
                  transform: "translate(14px, 10px) scale(1)",
                  "&.MuiInputLabel-shrink": {
                    transform: "translate(14px, -9px) scale(0.75)"
                  }
                }
              }} value={searchShopper} label="Search Shopper" onChange={(e) => { setsearchShopper(e.target.value) }} />
            </FormControl>
            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
              <Autocomplete
                disablePortal
                disableClearable
                id="status-autocomplete"
                options={statusOptions}
                getOptionLabel={(option: any) => option.label}
                value={statusOptions.find((option) => option.value === status) || null}
                onChange={(event, newValue: any) => setStatus(newValue?.value || "")}
                renderInput={(params) => <TextField {...params} label="Select Status" />}
                size="small"
              />
            </FormControl>
            <GoogleAutocomplete
              onLoad={(auto) => setAutocomplete(auto)}
              onPlaceChanged={() => {
                const place = autocomplete?.getPlace();

                if (!place?.geometry) return;

                const suburbComponent = place.address_components?.find((component: any) =>
                  component.types.includes("locality")
                );

                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();

                setSuburb(suburbComponent?.long_name || null);
                setLatitude(lat);
                setLongitude(lng);
                setInputValue(place.formatted_address || "");
              }}
              options={{
                types: ["(regions)"],
                componentRestrictions: { country: "au" },
              }}
            >
              <TextField
                fullWidth
                size="small"
                label="Select Suburb"
                value={inputValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setInputValue(value);

                  if (!value) {
                    setSuburb(null);
                    setLatitude(null);
                    setLongitude(null);
                  }
                }}
              />
            </GoogleAutocomplete>
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }} order={{ xs: 1, md: 2 }}>
            <Typography className="fs-42 text-center">Shopper Applications</Typography>
          </Grid>
        </Grid>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className="table-row-background">
                {[
                  "First Name",
                  "Last Name",
                  "Email",
                  "Date/Time",
                  "Age",
                  "Suburb",
                  "State",
                  "View",
                  "Approve",
                  ...(status !== "reject" ? ["Reject"] : []),
                  ...(status == "pending" ? ["Delete"] : []),
                ].map((item, index) => (
                  <TableCell key={index} style={{ color: "#fff" }}>
                    {item}
                  </TableCell>
                ))}
                {/* <TableCell></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {shopperApplications.slice().sort((a, b) => {
                const aDate = a.shopperOtherDetails?.[0]?.createdOn;
                const bDate = b.shopperOtherDetails?.[0]?.createdOn;
                return getDayGapFromToday2(bDate) - getDayGapFromToday2(aDate);
              })?.map((shopper) => {
                const days: any = getDayGapFromToday(shopper?.createdOn);
                return (
                  <TableRow>
                    <TableCell>{shopper.firstName}</TableCell>
                    <TableCell>{shopper.lastName}</TableCell>
                    <TableCell>{shopper.emailId}</TableCell>
                    <TableCell>
                      <Box>
                        {formatDateIfExists(shopper?.createdOn)} <br />
                        {/* <span style={{ color: days == 0 ? 'red' : '' }}>{getDayGapFromToday(shopper?.createdOn)}</span> */}
                        <Typography
                          variant="caption"
                          className="text-center"
                          sx={{ color: days <= 0 ? "red" : "" }}
                        >
                          {days !== null
                            ? days > 0
                              ? `${Math.floor(days)} days left`
                              : `${Math.abs(Math.floor(days))} days overdue`
                            : ""}
                        </Typography>
                        {/* <Typography variant="caption" className="text-center" sx={{ color: getDayGapFromToday(shopper?.createdOn) == 0 ? 'red' : '' }}>{getDayGapFromToday(shopper?.createdOn) ? Number(getDayGapFromToday(shopper?.createdOn)) > 0 ? ' days left' : ' days overdue' : ''}</Typography> */}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {(() => {
                        const dob = new Date(shopper.dob);
                        const diffMs = Date.now() - dob.getTime();
                        const ageDate = new Date(diffMs);
                        const age = Math.abs(ageDate.getUTCFullYear() - 1970);
                        return isNaN(age) ? "" : age;
                      })()}
                    </TableCell>
                    <TableCell
                      sx={{ cursor: "pointer", textDecoration: 'underline' }}
                      onClick={(e) => handleClick(e, shopper.city, shopper.state)}
                    >
                      {shopper.city}
                    </TableCell>
                    <TableCell >{shopper.state}</TableCell>
                    <TableCell>
                      <Link
                        to={`/admin/shoppers/view-shopper-application/${shopper?.userId}`}
                        className="table-row-background link-btn"
                        // onClick={() => navigateToViewShopperApplication(shopper)}
                      >
                        View Application
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        className="table-row-background"
                        onClick={() => updateApplicationStatus(shopper, "approve")}
                      >
                        Approve
                      </Button>
                    </TableCell>
                    {status !== "reject" && (
                      <>
                        <TableCell>
                          <Button
                            variant="contained"
                            className="table-row-background"
                            // onClick={() => updateApplicationStatus(shopper, "reject")}
                            onClick={() => {
                              setSelectedShopper(shopper);
                              setOpenRejectDialog(true);
                            }}
                          >
                            Reject
                          </Button>
                        </TableCell>
                      </>
                    )}
                   {status == "pending" && ( <TableCell>
                      <Button
                        variant="contained"
                        className="table-row-background"
                        onClick={() => handleDeleteUser(shopper?.userId)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                    )}
                    {/* <TableCell>
                <Button variant="contained" className="delete-transparent">
                  <DeleteIcon className="delete-icon" />
                </Button>
              </TableCell> */}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Box>
      </Box>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datalength}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Dialog open={openRejectDialog} onClose={() => setOpenRejectDialog(false)}>
        <DialogTitle>Select Reject Reason</DialogTitle>
        <DialogContent>
          <RadioGroup
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
          >
            <FormControlLabel value="Invalid ID" control={<Radio />} label="Invalid ID" />
            <FormControlLabel value="Not Following Instructions" control={<Radio />} label="Not Following Instructions" />
            <FormControlLabel value="Spelling/Grammer" control={<Radio />} label="Spelling/Grammer" />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenRejectDialog(false); setRejectReason("") }} >Cancel</Button>
          <Button
            variant="contained"
            sx={{ background: "#ADB792" }}
            disabled={!rejectReason}
            onClick={async () => {
              if (!selectedShopper) return;
              await updateApplicationStatus(selectedShopper, "reject", rejectReason);
              setOpenRejectDialog(false);
              setRejectReason("");
            }}
          >
            Confirm Reject
          </Button>
        </DialogActions>
      </Dialog>


      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            width: 500,
            height: 400,
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
          },
        }}
      >
        {activeLocation && (
          <iframe
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              `${activeLocation.city}, ${activeLocation.state}`
            )}&output=embed`}
          />
        )}
      </Popover>

    </div>
  );
};

export default ShopperApplications;
